import React, { useState } from "react";
import ReactPhoneInput from "react-phone-input-2";
import { parsePhoneNumberFromString } from "libphonenumber-js";

import "react-phone-input-2/lib/style.css";

const PhoneInput = ({ onChange, value, ...props }) => {
   const [error, setError] = useState();

   const validatePhoneNumber = (val, countryCode) => {
      if (!val) {
         onChange(val, "This field is required");
         return setError("This field is required");
      }
      const phoneNumber = parsePhoneNumberFromString(val, countryCode);

      if (!phoneNumber || !phoneNumber.isValid()) {
         onChange(val, "Invalid phone number");
         return setError("Invalid phone number");
      }
      setError(null);
      onChange(val, false);
   };

   return (
      <ReactPhoneInput
         value={value}
         country={"us"}
         autoFormat={false}
         onChange={(_, { countryCode }, _2, val) => {
            onChange(val, !!value ? error : true);
         }}
         onBlur={() => {
            validatePhoneNumber(value, "us");
         }}
         jumpCursorToEnd={false}
         {...props}
      />
   );
};

export default PhoneInput;
